'use client';

import Script from 'next/script';

export interface TagManagerProps {
  gtmId?: string;
  onSetUserId?: () => Promise<void>;
}

function TagManager({ gtmId, onSetUserId }: TagManagerProps) {
  const handleSetUserId = async () => {
    if (onSetUserId) {
      await onSetUserId();
    }
  };

  return (
    <>
      {gtmId && (
        <Script
          id='gtm'
          strategy='afterInteractive'
          // biome-ignore lint/security/noDangerouslySetInnerHtml: Google Tag Manager script requires dangerouslySetInnerHTML
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');`,
          }}
          onReady={() => {
            handleSetUserId();
          }}
        />
      )}
    </>
  );
}

export default TagManager;
